import { Box, Grid } from '@mui/material'
import React from 'react'
import BlogaLogo from '../../assets/bloga-white.png'
import Background from '../../assets/register-bg.png'
import { RegisterBrandForm } from '../../components/RegisterBrandForm/RegisterBrandForm'
import { RegisterInfluencerForm } from '../../components/RegisterInfluencerForm/RegisterInfluencerForm'
import { useAppMediaQuery } from '../../hooks/useAppMediaQuery'

export const Register = ({ mode = 'brand' }) => {
  const { isTablet } = useAppMediaQuery()
  return (
    <Box
      p={5}
      style={{
        minWidth: '100vw',
        minHeight: '100vh',
        width: '100%',
        height: '100%',
        paddingTop: 20,
        paddingBottom: 40,
        backgroundImage: isTablet ? 'none' : `url(${Background})`,
        backgroundPosition: '0 200px, top center, bottom center',
        backgroundRepeat: 'no-repeat ',
        backgroundAttachment: 'fixed, fixed, fixed'
      }}
    >
      <Grid container spacing={isTablet ? 4 : 0}>
        <Grid item xs={12} md={6}>
          <Box
            width={isTablet ? '100%' : '50%'}
            display='flex'
            justifyContent='center'
            position={isTablet ? undefined : 'fixed'}
          >
            <img width='150px' src={BlogaLogo} />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          {mode === 'brand' ? (
            <RegisterBrandForm />
          ) : (
            <RegisterInfluencerForm />
          )}
        </Grid>
      </Grid>
    </Box>
  )
}

export default Register
